import difference from 'lodash/difference';

import { mdiLibraryBooks } from '@lumapps/lumx/icons';
import { GLOBAL } from '@lumapps/translations';
import { HTML_ALLOWED_ATTRIBUTES, HTML_ALLOWED_TAGS } from '@lumapps/widget-html/constants';

import { WIDGET_CONTENT_LIST } from './keys';

export const WIDGET_CONTENT_LIST_TYPE = 'content-list';
export const WIDGET_CONTENT_LIST_ICON = mdiLibraryBooks;
export const WIDGET_CONTENT_LIST_EDITION_SCOPE = 'widget-content-list-edition';

export const CONTENT_LIST_HTML_ALLOWED_TAGS = difference(
    HTML_ALLOWED_TAGS,
    // Exclude tags that are not allowed in content list
    ['script', 'style', 'embed'],
);

export const CONTENT_LIST_HTML_ALLOWED_ATTRIBUTES = [...HTML_ALLOWED_ATTRIBUTES];

export const DEFAULT_CONTENT_LIST_MAX_ITEMS = 5;

export const SORT_OPTIONS = {
    updatedAt: {
        label: GLOBAL.LAST_UPDATED_DATE,
        order: [
            {
                label: GLOBAL.LATEST_TO_OLDEST,
                value: 'desc',
            },
            {
                label: GLOBAL.OLDEST_TO_LATEST,
                value: 'asc',
            },
        ],
    },
    publicationDate: {
        label: WIDGET_CONTENT_LIST.SORT_PUBLICATION_DATE_LABEL,

        order: [
            {
                label: GLOBAL.LATEST_TO_OLDEST,
                value: 'desc',
            },
            {
                label: GLOBAL.OLDEST_TO_LATEST,
                value: 'asc',
            },
        ],
    },
    title: {
        label: GLOBAL.TITLE,
        order: [
            {
                label: GLOBAL.SORT_ALPHABETICALLY_ASC,
                value: 'asc',
            },
            {
                label: GLOBAL.SORT_ALPHABETICALLY_DESC,
                value: 'desc',
            },
        ],
    },
    author: {
        label: GLOBAL.AUTHOR,
        order: [
            {
                label: GLOBAL.SORT_ALPHABETICALLY_ASC,
                value: 'asc',
            },
            {
                label: GLOBAL.SORT_ALPHABETICALLY_DESC,
                value: 'desc',
            },
        ],
    },
    likes: {
        label: GLOBAL.LIKES,
        order: [
            {
                label: GLOBAL.SORT_LIKES_DESC,
                value: 'desc',
            },
            {
                label: GLOBAL.SORT_LIKES_ASC,
                value: 'asc',
            },
        ],
    },
    comments: {
        label: GLOBAL.COMMENTS,
        order: [
            {
                label: GLOBAL.SORT_COMMENTS_DESC,
                value: 'desc',
            },
            {
                label: GLOBAL.SORT_COMMENTS_ASC,
                value: 'asc',
            },
        ],
    },
};
